import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { PrimaryButton } from '../../components/StyledButton'
import ElectricalPlug from '../../assets/images/design/NotFoundPage/ElectricalPlug'
import CircleIcon64pxSvg from '../../assets/images/design/NotFoundPage/CircleIcon64pxSvg'
import CircleIcon28pxSvg from './../../assets/images/design/NotFoundPage/CircleIcon28pxSvg';
import CircleIcon83pxSvg from './../../assets/images/design/NotFoundPage/CircleIcon83pxSvg';
import Xicon71pxSvg from '../../assets/images/design/NotFoundPage/Xicon71pxSvg'
import XIcon52pxSvg from './../../assets/images/design/NotFoundPage/XIcon52pxSvg';
import Xicon24pxSvg from './../../assets/images/design/NotFoundPage/Xicon24pxSvg';

const NotFound = () => {
    const {t} = useTranslation()

    const navigate = useNavigate()

    return (
        <div className='w-full bg-white relative overflow-hidden'>
            <ElectricalPlug className="absolute top-[-30%] left-[3%] hidden xl:block" />
            <CircleIcon28pxSvg className="absolute top-[15%] left-[47%] hidden md:block"/>
            <CircleIcon64pxSvg className="absolute top-[80%] left-[18%] hidden md:block" />
            <CircleIcon83pxSvg className="absolute top-[5%] left-[70%] hidden md:block" />
            <Xicon24pxSvg className="absolute top-[45%] left-[25%] hidden md:block" />
            <XIcon52pxSvg className="absolute top-[30%] left-[30%] hidden lg:block" />
            <Xicon71pxSvg className="absolute top-[80%] left-[70%] hidden md:block" />
            <div className='flex flex-col justify-center items-center text-center py-[50px] md:py-[150px]'>
                <p className='text-primary text-[64px] md:text-[128px] font-semibold leading-tight'>404</p>
                <p className='text-primary text-[40px] md:text-[64px] font-bold leading-tight'>{t('404-page.page-not-found')}</p>
                <p className='text-xl md:text-2xl font-medium'>{t('404-page.oops')}</p>
                <div className='pt-10'>
                    <PrimaryButton onClick={() => navigate("/")}>{t('button.go-to-home')}</PrimaryButton>
                </div>
            </div>
        </div>
    )
}

export default NotFound